const firebaseConfig = {
    apiKey: "AIzaSyDskOMRBhBDZFij3sClldY9QqRKmQngaF8",
    authDomain: "assignment-11-4e29f.firebaseapp.com",
    projectId: "assignment-11-4e29f",
    storageBucket: "assignment-11-4e29f.appspot.com",
    messagingSenderId: "714123679035",
    appId: "1:714123679035:web:ad7858994a6cbc0192931e"
  };
  export default firebaseConfig;